export const TRIGGER = 'click'
